function updatePromoMessage() {
  fetch('/cart.js') 
    .then(response => response.json())
    .then(cart => {
      let totalItems = 0;
      cart.items.forEach(item => {
        totalItems += item.quantity;
      });

      let promoMessage = document.getElementById('promo-message');
      if (!promoMessage) {
        promoMessage = document.createElement('div');
        promoMessage.id = 'promo-message';
        promoMessage.className = 'promo-message hidden';

        const cartContainer = document.querySelector('.quick-cart__items'); 
        if (cartContainer) {
          cartContainer.insertAdjacentElement('beforebegin', promoMessage);
        } else {
          console.error('Impossible de trouver le conteneur du panier.');
          return;
        }
      }

      let remaining = 3 - totalItems;

      if (totalItems === 0) {
        promoMessage.classList.add('hidden');
      } else {
        promoMessage.classList.remove('hidden');

        if (remaining > 0) {
          promoMessage.innerHTML = `
            <div>
              Add <strong>${remaining}</strong> more item${remaining > 1 ? 's' : ''} to unlock <strong>Buy 2 Get 1 Free</strong><br>
              <em><strong>Free Styling Guide Inside.</strong></em>
            </div>
          `;
        } else {
          promoMessage.innerHTML = `
            <div>
              <em><strong>Free Styling Guide Inside.</strong></em>
            </div>
          `;
        }
      }
    })
    .catch(error => {
      console.error('Erreur lors de la récupération du panier :', error);
    });
}

function waitForCartAndUpdate() {
  const checkCartInterval = setInterval(() => {
    const cartContainer = document.querySelector('.quick-cart__items'); 
    if (cartContainer) {
      clearInterval(checkCartInterval); 
      updatePromoMessage(); 
      observeCartChanges(); 
    }
  }, 200); 
}

function observeCartChanges() {
  const cartContainer = document.querySelector('.quick-cart__items');
  if (!cartContainer) {
    console.error('Le conteneur du panier (.quick-cart__items) est introuvable.');
    return;
  }

  const observer = new MutationObserver((mutations) => {
    let hasCartChanged = false;

    mutations.forEach(mutation => {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        hasCartChanged = true;
      }
    });

    if (hasCartChanged) {
      updatePromoMessage();
    }
  });

  observer.observe(cartContainer, { childList: true, subtree: true, attributes: true });

  const bodyObserver = new MutationObserver(() => {
    const newCartContainer = document.querySelector('.quick-cart__items');
    if (!newCartContainer) {
      waitForCartAndUpdate(); 
    }
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', () => {
  waitForCartAndUpdate();
});